var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 75,
    viewBox: "0 0 382 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1835_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6026 59.3052L34.8887 74.1047L52.2897 74.0646L43.6026 59.3052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1751 29.6526L0 74.078H17.4278L34.889 44.4522L26.1751 29.6526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3105 44.6058L69.8854 74.332H87.2263L60.9776 29.8865L52.3105 44.6058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2897 14.7528L43.6026 0L34.8887 14.7929L43.5758 29.5523L52.2897 14.7528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.216 31.7188C209.535 31.7188 214.784 36.5473 214.784 44.666C214.784 51.0258 210.11 55.6269 203.322 56.5564L216.035 74.0979H206.499L194.274 57.4994H177.167V74.0979H169.684V31.7122H197.223L197.216 31.7188ZM177.16 39.1888V50.1431H198.286C202.653 50.1431 207.294 49.7886 207.294 44.666C207.294 39.5433 201.342 39.1888 198.132 39.1888H177.154H177.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.611 74.8067L289.658 47.1604L287.866 45.6891V74.1045H280.383V31.0166H280.463L314.416 58.663L316.208 60.1342V31.7188H323.691V74.8067H323.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.914 74.1048H162.769L136.881 30.114H136.727L110.84 74.1048H119.694L124.128 66.4475H149.414L153.914 74.1048ZM136.801 44.2983C140.432 50.1499 141.99 52.9119 145.649 59.138H127.88C131.698 52.6645 133.143 50.1499 136.801 44.2983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.147 74.1048H382.001L356.114 30.114H355.96L330.072 74.1048H338.927L343.36 66.4475H368.646L373.147 74.1048ZM356.033 44.2983C359.665 50.1499 361.223 52.9119 364.881 59.138H347.112C350.931 52.6645 352.375 50.1499 356.033 44.2983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.836 66.628V56.356H264.9V49.0465H235.836V39.1957H268.224V31.719H228.346V74.1047H269.394V66.628H235.836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1835_1644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 74.807,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.871c4b998a26ff5f133e8cc19b0676fa.svg";
export { ForwardRef as ReactComponent };